import { render, staticRenderFns } from "./data-import.vue?vue&type=template&id=32971c3f"
import script from "./data-import.vue?vue&type=script&lang=ts"
export * from "./data-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports